import { call, put } from 'redux-saga/effects';
import { arrayToEntityMap } from "lib/data";

import { sendTeachersDataRequest } from "state/fetchSagas";
import { fetchSchoolsSucceeded } from "state/teachers/actions";

import School from "state/teachers/entities/School";

export default function* fetchSchools(action) {
  
  const response = yield call(sendTeachersDataRequest, "get_my_schools");
  
  const schoolsByID = arrayToEntityMap(School.fromAppserverValueList, school => school.id, response.data);

  // Neo schools that come from classic will pass an additional "classicId" parameter to indicate which classic T2P account they were migrated from.
  const neoSchools = schoolsByID.filter(s => s.classicId != null);
  
  // Update the migrated schools classic accounts with their corresponding Neo ID.
  const migratedSchools = schoolsByID.filter(s => neoSchools.some(n => n.classicId === s.remoteSchoolID)).map(s => s.set("neoId", neoSchools.find(n => n.classicId === s.remoteSchoolID).schoolID));

  // Remove any schools whose "schoolID" matches a migrated school.
  const distinctSchools = schoolsByID.filter(s => !migratedSchools.some(m => m.schoolID === s.schoolID));

  yield put(fetchSchoolsSucceeded(distinctSchools, migratedSchools));
  
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/fetchSchools.js